/**
 * Build a SIWE (EIP-4361) message that matches backend parser expectations.
 */
export interface SiweParams {
  domain: string;
  address: `0x${string}`;
  uri: string;
  chainId: number;
  nonce: string;
  statement?: string;
  issuedAt?: string;
  expirationTime?: string;
  notBefore?: string;
}

export function buildSiweMessage(p: SiweParams): string {
  const lines: string[] = [
    `${p.domain} wants you to sign in with your Ethereum account:`,
    p.address,
    "",
  ];
  if (p.statement) {
    lines.push(p.statement);
  }
  lines.push(`URI: ${p.uri}`);
  lines.push(`Version: 1`);
  lines.push(`Chain ID: ${p.chainId}`);
  lines.push(`Nonce: ${p.nonce}`);
  lines.push(`Issued At: ${p.issuedAt ?? new Date().toISOString()}`);
  if (p.expirationTime) lines.push(`Expiration Time: ${p.expirationTime}`);
  if (p.notBefore) lines.push(`Not Before: ${p.notBefore}`);
  return lines.join("\n");
}
